import { graphql } from "../gql";

export const sendResetPasswordEmail = graphql(`
  mutation SendResetPasswordEmail($email: String!, $template: String!) {
    sendResetPasswordEmail(input: { email: $email, template: $template }) {
      success
      error {
        message
      }
    }
  }
`);
